import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import { SUPPORTED_LANGUAGES } from '../i18n/translations';

const LanguageSelector = ({ compact = false }) => {
  const { language, setLanguage, t } = useI18n();

  return (
    <label className={`language-selector${compact ? ' language-selector--compact' : ''}`}>
      <span>{t('language.label')}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={t('language.select')}
      >
        {SUPPORTED_LANGUAGES.map(({ code, label, shortLabel }) => (
          <option value={code} key={code}>{compact ? shortLabel : label}</option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSelector;
